import * as Types from '../../generated/types';

import gql from 'graphql-tag';
import { OmiUserFragmentDoc, OmiCustomerFragmentDoc, OmiCustomerTierSettingsFragmentDoc } from './OmiUserContext.generated';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ICurrentOmiUserProfileQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ICurrentOmiUserProfileQuery = { __typename?: 'Query', getActiveFeatures: Array<Types.IFeatureFlag>, liteGetCurrentUserProfile: { __typename?: 'LiteGetCurrentUserProfileResponse', userProfile?: { __typename: 'User', id: string, firstName: string, lastName: string } | { __typename: 'UserNotSignedUp' } | null, customer?: { __typename: 'Customer', id: string, sheetsTier: Types.ISheetsCustomerTier } | null, errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null }, getSheetsTierSettings: { __typename?: 'GetSheetsTierSettingsResponse', tierSettings?: { __typename: 'SheetsTierSettings', maxUsers: number, maxContracts: number, cashFlowEnabled: boolean, accountIntegrationEnabled: boolean, exportEnabled: boolean, tierQuotaUsage: { __typename?: 'SheetsTierQuotaUsage', users: number, contracts: number } } | null, errors?: Array<{ __typename?: 'DefaultError', message: string, stackTrace?: string | null }> | null }, getOmiUserProfile: { __typename?: 'GetOmiUserProfileResponse', contractsEmailAddress?: string | null }, getUserPermissions: { __typename?: 'PermissionsResponse', permissions: Array<string> } };


export const CurrentOmiUserProfileDocument = gql`
    query CurrentOmiUserProfile {
  liteGetCurrentUserProfile {
    userProfile {
      ... on User {
        __typename
        ...OmiUser
      }
      ... on UserNotSignedUp {
        __typename
      }
    }
    customer {
      ...OmiCustomer
    }
    errors {
      message
      stackTrace
    }
  }
  getSheetsTierSettings {
    tierSettings {
      ...OmiCustomerTierSettings
    }
    errors {
      message
      stackTrace
    }
  }
  getOmiUserProfile {
    contractsEmailAddress
  }
  getUserPermissions {
    permissions
  }
  getActiveFeatures
}
    ${OmiUserFragmentDoc}
${OmiCustomerFragmentDoc}
${OmiCustomerTierSettingsFragmentDoc}`;

export function useCurrentOmiUserProfileQuery(options?: Omit<Urql.UseQueryArgs<ICurrentOmiUserProfileQueryVariables>, 'query'>) {
  return Urql.useQuery<ICurrentOmiUserProfileQuery, ICurrentOmiUserProfileQueryVariables>({ query: CurrentOmiUserProfileDocument, ...options });
};